import VendorLogo from '../components/VendorLogo';
import { useTranslate } from '../lib/i18n';

const IntakeHeader = () => {
  const t = useTranslate();

  return (
    <div className="shrink-0 w-full z-50 h-16 bg-sidebar text-sidebar-foreground shadow-md flex items-center justify-center">
      <div className="flex justify-start items-center gap-4 px-4 max-w-lg w-full">
        <div>
          <VendorLogo className="h-8 w-8" usage="header" />
        </div>
        <span className="text-ls">{t('riku.title')}</span>
      </div>
    </div>
  );
};

export default IntakeHeader;
